import { controls } from "../../controls";

const rp1202 = {
  label: "Form16 Salary Certificate",
  pageLabel: "Form16 Salary Certificate",
  starting: true,
  url: "rp1202",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "Modal", label: "Employee Code", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "Modal", name: "employee_code", width: "col-sm-2", placeHolder: "Pf Number" }),    
     
  
//...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    
    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"from_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"to_date",width:"col-sm-2"}),
     
    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "Form16 Salary Certificate",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      {
        
        Header: "Mon Year",
        accessor: "mon_year",
        width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "Basic",
        accessor: "basic",
        type: "Currency",
//width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "FDA",
        accessor: "fda",
        type: "Currency",
       // width: 80,
        //rwidth:"10"
      },


      {
        
        Header: "VARDA",
        accessor: "varda",
        type: "Currency",
       // width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "HRA",
        accessor: "hra",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },


      {
        
        Header: "Type Alw",
        accessor: "type_alw",
        type: "Currency",
//width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "DRVR Alw",
        accessor: "drvr_alw",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "WASH Alw",
        accessor: "wash_alw",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "CASH Alw",
        accessor: "cash_alw",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },
       
      {
        
        Header: "OFF Alw",
        accessor: "off_alw",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },


      {
        
        Header: "CLG Alw",
        accessor: "clg_alw",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },


      {
        
        Header: "SPCL Alw",
        accessor: "spcl_alw",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "MDA",
        accessor: "mda",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "Gross Sal",
        accessor: "gross_sal",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "PT",
        accessor: "pt",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "PF",
        accessor: "pf",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "INSU",
        accessor: "insu",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "TDS",
        accessor: "tds",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "HSG Ln",
        accessor: "hsg_ln",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "Deduct",
        accessor: "deduct",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },

      {
        
        Header: "Net Pay",
        accessor: "net_pay",
        type: "Currency",
        //width: 80,
        //rwidth:"10"
      },




        
      
    ]
  }
};

export default rp1202;